const initialState = {
    excludeApmId: null,
    fields: [],
    locationInfoTitle: null,
    titles: [],
};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'LOCATION_INFO_TITLES_SUCCESS') {
        return { ...state, excludeApmId: action.actionParams.excludeApmId, titles: action.payload };
    }

    if (action.type === 'LOCATION_INFO_FIELDS_SUCCESS') {
        return {
            ...state,
            fields: action.payload,
            locationInfoTitle: action.actionParams.locationInfoTitle,
        };
    }

    return state;
}

export default reducer;
